import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, XCircle, Home, Target } from 'lucide-react';
import { Button } from '../components/ui/button';

const ConfirmAppointment = () => {
  const { appointmentId } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    confirmAppointment();
  }, [appointmentId]);

  const confirmAppointment = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/appointments/${appointmentId}/confirm`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message || 'Termin erfolgreich bestätigt!');
      } else {
        setStatus('error');
        setMessage(data.detail || 'Fehler beim Bestätigen des Termins');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Verbindungsfehler. Bitte versuchen Sie es später erneut.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {status === 'loading' && (
            <>
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-accent mx-auto mb-4"></div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Termin wird bestätigt...
              </h2>
              <p className="text-gray-600">Bitte warten Sie einen Moment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="bg-green-100 rounded-full p-4 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                <CheckCircle2 className="h-12 w-12 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                ✅ Termin bestätigt!
              </h2>
              <p className="text-gray-600 mb-6">{message}</p>
              <p className="text-sm text-gray-500 mb-6">
                Der Kunde hat eine Bestätigungs-E-Mail erhalten.
              </p>
              <Link to="/">
                <Button className="w-full" size="lg">
                  <Home className="h-5 w-5 mr-2" />
                  Zur Startseite
                </Button>
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="bg-red-100 rounded-full p-4 w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                <XCircle className="h-12 w-12 text-red-600" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Fehler
              </h2>
              <p className="text-gray-600 mb-6">{message}</p>
              <Link to="/">
                <Button className="w-full" size="lg">
                  <Home className="h-5 w-5 mr-2" />
                  Zur Startseite
                </Button>
              </Link>
            </>
          )}
        </div>

        <div className="text-center mt-6">
          <Link to="/" className="flex items-center justify-center text-gray-600 hover:text-accent">
            <Target className="h-5 w-5 mr-2" />
            <span className="font-semibold">Daniel Leismann - Digitale Prozessoptimierung</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAppointment;
